"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _InfoLabel = _interopRequireDefault(require("../../../components/InfoLabel"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _CustomFields = _interopRequireDefault(require("./CustomFields"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fields = ['firstName', 'lastName', 'username', 'passcode', 'field1', 'field2', 'field3', 'field4', 'field5', 'email', 'phone', 'role', 'group'];
var Form = /*#__PURE__*/function (_React$Component) {
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Form, [].concat(args));
    _defineProperty(_this, "componentDidMount", function () {
      _this.props.fields.role.onChange(_this.props.forCycle.roleHandle);
      _this.props.fields.group.onChange(_this.props.projectId);
    });
    return _this;
  }
  _inherits(Form, _React$Component);
  return _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props$fields = this.props.fields,
        firstName = _this$props$fields.firstName,
        lastName = _this$props$fields.lastName,
        username = _this$props$fields.username,
        passcode = _this$props$fields.passcode,
        field1 = _this$props$fields.field1,
        field2 = _this$props$fields.field2,
        field3 = _this$props$fields.field3,
        field4 = _this$props$fields.field4,
        field5 = _this$props$fields.field5,
        email = _this$props$fields.email,
        phone = _this$props$fields.phone;
      var _this$props = this.props,
        handleSubmit = _this$props.handleSubmit,
        isEditing = _this$props.isEditing,
        submitting = _this$props.submitting;
      var individualPasscode = this.props.forCycle.settings.individualPasscode;
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: firstName,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "First Name",
          optional: true
        })
      }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: lastName,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Last Name",
          optional: true
        })
      }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: username,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Username",
          tooltip: "A username will be generated if not provided",
          optional: true
        }),
        disabled: isEditing
      }), individualPasscode && /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: passcode,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Passcode",
          tooltip: "A passcode will be auto-generated if not provided",
          optional: true
        })
      }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: email,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Email",
          tooltip: "If provided, the respondent will receive messaging here.",
          optional: true
        })
      }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: phone,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Phone",
          tooltip: "If provided, the respondent will receive messaging here.",
          optional: true
        })
      }), /*#__PURE__*/_react["default"].createElement(_CustomFields["default"], {
        customFields: [{
          field: field1,
          name: 'field_1'
        }, {
          field: field2,
          name: 'field_2'
        }, {
          field: field3,
          name: 'field_3'
        }, {
          field: field4,
          name: 'field_4'
        }, {
          field: field5,
          name: 'field_5'
        }]
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'flex-end'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-primary",
        isLoading: submitting,
        onClick: handleSubmit
      })));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Form, "propTypes", {
  fields: _propTypes["default"].object,
  handleSubmit: _propTypes["default"].func,
  isEditing: _propTypes["default"].bool,
  submitting: _propTypes["default"].bool,
  forCycle: _propTypes["default"].object,
  projectId: _propTypes["default"].number
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    projectId: state.assignment.admin.currentProjectId
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)({
  form: 'TestForm',
  fields: fields
})(Form));